// src/components/optimiseur/AjoutsValides.jsx — CE QUI A ÉTÉ AJOUTÉ AU CV, PAR
// QUI, QUAND, ET CE QU'EN A DIT LE CANDIDAT (onglet Historique).
//   GET /besoins/:bid/cv-ajouts/:cid → { missions, ajouts }
import React, { useEffect, useState } from 'react';
import { appel, dateHeure } from './api';

const BI = ({ icon }) => <i className={`bi bi-${icon}`} aria-hidden="true" />;
const CANDIDAT = { valide: 'validé par le candidat', corrige: 'corrigé par le candidat', refuse: 'refusé par le candidat' };

export default function AjoutsValides({ besoinId, candidateId }) {
  const [etat, setEtat] = useState({ etat: 'loading' });

  useEffect(() => {
    let vivant = true;
    (async () => {
      try {
        const { r, j, absente } = await appel(`/besoins/${besoinId}/cv-ajouts/${candidateId}`);
        if (!vivant) return;
        if (absente) { setEtat({ etat: 'route' }); return; }
        if (!r.ok || j.success === false) throw new Error(j.error || `Les ajouts n'ont pas pu être lus (${r.status}).`);
        setEtat({ etat: 'ready', ajouts: Array.isArray(j.ajouts) ? j.ajouts : [] });
      } catch (e) { if (vivant) setEtat({ etat: 'error', erreur: e.message }); }
    })();
    return () => { vivant = false; };
  }, [besoinId, candidateId]);

  if (etat.etat === 'route') return null;
  if (etat.etat === 'loading') return <p className="opt-muet"><BI icon="arrow-repeat" /> Lecture des ajouts…</p>;
  if (etat.etat === 'error') return <p className="opt-erreur">{etat.erreur}</p>;
  const valides = etat.ajouts.filter(a => a.statut === 'valide');
  const retires = etat.ajouts.filter(a => a.statut === 'retire').length;
  const sansOui = etat.ajouts.filter(a => a.statut === 'retire' && a.reponse === 'sans_oui').length;
  if (!valides.length) return <p className="opt-muet">Aucun ajout validé pour ce profil.{retires ? ` ${retires} proposition${retires > 1 ? 's' : ''} retirée${retires > 1 ? 's' : ''}.` : ''}</p>;
  return (
    <>
      {valides.map(a => (
        <div key={a.id} className="opt-reponse">
          <BI icon="plus-square" />
          <div className="opt-reponse__corps">
            <div className="opt-reponse__critere">{a.critere}{a.mission_libelle ? ` — ${a.mission_libelle}` : ''}</div>
            <div className="opt-reponse__texte">{a.texte}</div>
            {a.place_par_leman && <div className="opt-reco__puces"><span className="opt-puce opt-puce--confirmer"><BI icon="geo-alt" /> Placé par Leman · à vérifier</span></div>}
            {a.contexte && <div className="opt-note">Précision : {a.contexte}</div>}
            <div className="opt-note">
              {[a.confirme_par_nom ? `confirmé par ${a.confirme_par_nom}` : 'confirmé', a.confirme_le ? `le ${dateHeure(a.confirme_le)}` : null].filter(Boolean).join(' ')}
              {a.candidat?.statut ? ` · ${CANDIDAT[a.candidat.statut] || a.candidat.statut}${a.candidat.le ? ` le ${dateHeure(a.candidat.le)}` : ''}` : ''}
            </div>
            {a.candidat?.statut === 'corrige' && a.candidat.texte && <div className="opt-carte__citation">Sa version : « {a.candidat.texte} »</div>}
          </div>
        </div>
      ))}
      {retires > 0 && <p className="opt-note">{retires} ajout{retires > 1 ? 's' : ''} retiré{retires > 1 ? 's' : ''}{sansOui ? `, dont ${sansOui} écrit${sansOui > 1 ? 's' : ''} sans « Oui »` : ''}.</p>}
    </>
  );
}
